<div
  class="mb-2 field flex flex-column w-full"
  [ngClass]="options.containerClass"
>
  <ng-container
    *ngIf="
      options.fieldFormGroup || options.fieldFormGroup === '';
      else elseTemplate
    "
  >
    <ng-container [formGroup]="specificFormGroup">
      <label class="mb-2" *ngIf="options.label | translate">
        {{ options.label | translate }}
      </label>

      <input
        [type]="options.type"
        [placeholder]="(options.placeholder | translate) ?? ''"
        [formControlName]="options.formControlName"
        (input)="onChange($event)"
        pInputText
      />
    </ng-container>
  </ng-container>
  <ng-template #elseTemplate>
    <ng-container *ngIf="customFormGroupName === undefined">
      <label *ngIf="options.label" class="mb-2">
        {{ options.label | translate }}
        <span
          *ngIf="options?.validators?.required"
          [pTooltip]="'BUTTONS.required' | translate"
          tooltipPosition="top"
          class="text-pink-500"
          >*</span
        >
      </label>
      <input
        *ngIf="options.type !== 'price'"
        [type]="options.type"
        [placeholder]="(options.placeholder | translate) ?? ''"
        [formControlName]="options.formControlName"
        (input)="onChange($event)"
        pInputText
      />
      <p-inputNumber
        *ngIf="options.type === 'price'"
        styleClass="w-full"
        [placeholder]="(options.placeholder | translate) ?? ''"
        [formControlName]="options.formControlName"
        (input)="onChange($event)"
        inputId="locale-user"
        [minFractionDigits]="2"
      >
      </p-inputNumber>
    </ng-container>

    <ng-container *ngIf="customFormGroupName !== undefined">
      <ng-container [formGroupName]="customFormGroupName">
        <h1>{{ customFormGroupName }}</h1>
        <label *ngIf="options.label" class="mb-2">
          {{ options.label | translate }}
        </label>
        <input
          [type]="options.type"
          [placeholder]="(options.placeholder | translate) ?? ''"
          [formControlName]="options.formControlName"
          (input)="onChange($event)"
          pInputText
        />
      </ng-container>
    </ng-container>
  </ng-template>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
